import axios from 'axios';
import Api from '../router/api';

export default async function checkSurveyProgress(to, from, next) {
    // Get the token from the route parameters
    const token = to.params.link; 

    if (!token) {
        next('/error'); // Redirect if no token is present
        return; // Stop further execution
    }

    try {
        // Make the API call and wait for the response
        const response = await Api.getNonEmployeeStep(token);

        if (response.data.status === 'success') {
            const step = response.data.res.step;

            // Determine which route to redirect to based on the step
            switch (step) {
                case 0:
                    if (to.path !== `/consent-page/${token}`) {
                        next(`/consent-page/${token}`);
                    } else {
                        next();
                    }
                    break;
                case 1:
                    if (to.path !== `/welcome-page/${token}`) {
                        next(`/welcome-page/${token}`);
                    } else {
                        next();
                    }
                    break;
                case 2:
                    if (to.path !== `/survey-one/${token}`) {
                        next(`/survey-one/${token}`);
                    } else {
                        next();
                    }
                    break;
                case 3:
                    if (to.path !== `/survey-two/${token}`) {
                        next(`/survey-two/${token}`);
                    } else {
                        next();
                    }
                    break;
                case 4:
                    if (to.path !== `/survey-three/${token}`) {
                        next(`/survey-three/${token}`);
                    } else {
                        next();
                        break;
                    }
                    break;
                case 5:
                    if (to.path !== `/survey-complete/${token}`) {
                        next(`/survey-complete/${token}`);
                    } else {
                        next();
                        break;
                    }
                    break;
                default:
                    next(`/survey-404/${token}`);
                    break;
            }
        } else {
            next('/survey-404'); // Redirect to an error page if the token is not found or any other issue occurs
        }
    } catch (error) {
        console.error(error);
        next('/survey-404'); // Redirect to an error page on API error
    }
}



// WEBPACK FOOTER //
// ./src/middleware/checkSurveyProgress.js